'use strict';
define([], function () {
    function SCLandingCtrl($scope, $state, $translate, $rootScope, TypedService, AuthService, LanguageService, $window, $interval, $timeout) {
        var vm = $scope;
        var typed;
        var placeholder;
        var destroyed = false;
        var sceneIndex = 0;
        var sceneTimer = null;
        var sceneInterval = null;
        var sceneTimeouts = [];
        var sceneOrder = ['search', 'solutions', 'score'];
        var sceneDurations = {search: 4300, solutions: 4700, score: 5100};
        var reducedMotion = !!($window.matchMedia && $window.matchMedia('(prefers-reduced-motion: reduce)').matches);

        vm.typeOfAnalysis = 'seo-checker';
        vm.analysisModeOptions = [
            {value: 'seo-checker', label: 'seochecker.analyze.website.only', icon: 'ti ti-file-search'},
            {value: 'seo-spider', label: 'seochecker.analyze.website.allwebsite', icon: 'ti ti-world-search'}
        ];
        vm.placeholderInput = $translate.instant('seochecker.first.placeholder');

        vm.landingScene = 'search';
        vm.landingScenes = [
            {id: 'search', icon: 'ti-search', key: 'seochecker.landing.scene.search'},
            {id: 'solutions', icon: 'ti-list-check', key: 'seochecker.landing.scene.fix'},
            {id: 'score', icon: 'ti-sparkles', key: 'seochecker.landing.scene.score'}
        ];
        vm.solutionItems = [
            {key: 'seochecker.landing.solutions.item.meta', priority: 'high', visible: false, resolved: false},
            {key: 'seochecker.landing.solutions.item.content', priority: 'high', visible: false, resolved: false},
            {key: 'seochecker.landing.solutions.item.performance', priority: 'medium', visible: false, resolved: false},
            {key: 'seochecker.landing.solutions.item.ai', priority: 'medium', visible: false, resolved: false}
        ];
        vm.solutionCount = 0;
        vm.initialScore = 48;
        vm.solutionsScore = vm.initialScore;
        vm.problemsFound = 12;
        vm.resolvedCount = 0;
        vm.searchTypedText = '';
        vm.searchTyping = false;
        vm.searchStarted = false;
        vm.searchButtonPressed = false;
        vm.searchChecks = [
            {key: 'seochecker.landing.search.check.title', done: false},
            {key: 'seochecker.landing.search.check.headings', done: false},
            {key: 'seochecker.landing.search.check.links', done: false},
            {key: 'seochecker.landing.search.check.performance', done: false},
            {key: 'seochecker.landing.search.check.accessibility', done: false}
        ];
        vm.totalChecks = 40;
        vm.searchProgress = 0;
        vm.searchScore = 0;

        if (!AuthService.isAuthenticated()) {
            vm.placeholderInput = "";
            placeholder = [$translate.instant('seochecker.first.placeholder'), $translate.instant('seochecker.second.placeholder')];
            typed = TypedService.createTyped(placeholder, '#search');
        }

        startPreview();

        vm.$on('languageChanged', function () {
            if ($state.current.url === '/seo-checker') {
                vm.placeholderInput = $translate.instant('seochecker.first.placeholder');
                if (!AuthService.isAuthenticated()) {
                    typed.destroy();
                    vm.placeholderInput = "";
                    placeholder = [$translate.instant('seochecker.first.placeholder'), $translate.instant('seochecker.second.placeholder')];
                    typed = TypedService.createTyped(placeholder, '#search');
                }
            }
        });

        vm.$on('$destroy', function () {
            destroyed = true;
            clearPreviewTimers();
            if (typed) {
                typed.destroy();
            }
        });

        vm.loading = false;
        vm.isNotUrl = false;
        var correct_url = new RegExp(/^((http:\/\/|https:\/\/)?(www\.|^\.)?((([\-|\wæÆØøÅå|\d]+)\.)+([a-zA-ZæÆØøÅå]{1,10}))(\/?(([a-zA-ZZæÆØøÅå0-9_@]+\.([a-zA-ZZæÆØøÅå0-9]{3,6}))?(\??[-A-Za-zæÆØøÅå0-9+:&@#\/%=~'_\.?|]+))){0,1})$/gim);
        vm.emptyPlace = function () {
            vm.placeholderInput = "";
        };

        vm.seochecker = function () {
            if (vm.searchText && vm.searchText.length > 0 && vm.searchText.match(correct_url)) {
                if (vm.typeOfAnalysis === 'seo-spider') {
                    $state.go('app.project.wizard', {url: vm.searchText, from: 'seo-checker-landing', step: 'create-project'});
                    return;
                }
                $state.go('app.seochecker.results.overview', {url: encodeURIComponent(btoa(vm.searchText))});
            } else {
                vm.isNotUrl = true;
                $timeout(function () {
                    vm.isNotUrl = false;
                }, 5000);
            }
        };

        vm.selectLandingScene = function (index) {
            if (destroyed) {
                return;
            }
            playScene(index);
        };

        function startPreview() {
            if (reducedMotion) {
                showFinalState();
                return;
            }
            sceneTimeouts.push($timeout(function () {
                playScene(0);
            }, 350));
        }

        function playScene(index) {
            if (destroyed) {
                return;
            }

            clearPreviewTimers();
            sceneIndex = index % sceneOrder.length;
            vm.landingScene = sceneOrder[sceneIndex];
            resetPreviewState();

            if (vm.landingScene === 'search') {
                runSearchPreview();
            } else if (vm.landingScene === 'solutions') {
                runSolutionsPreview();
            } else {
                runOutcomePreview();
            }

            sceneTimer = $timeout(function () {
                playScene(sceneIndex + 1);
            }, sceneDurations[vm.landingScene]);
        }

        function resetPreviewState() {
            vm.searchProgress = 0;
            vm.searchScore = 0;
            vm.searchTypedText = '';
            vm.searchTyping = false;
            vm.searchStarted = false;
            vm.searchButtonPressed = false;
            vm.searchChecks.forEach(function (check) {
                check.done = false;
            });
            vm.solutionCount = 0;
            vm.solutionItems.forEach(function (item) {
                item.visible = false;
                item.resolved = false;
            });
            vm.solutionsScore = vm.initialScore;
            vm.problemsFound = 12;
            vm.resolvedCount = 0;
        }

        function runSearchPreview() {
            var target = 'www.il-tuo-sito.com';
            var position = 0;
            vm.searchTyping = true;
            sceneInterval = $interval(function () {
                position = Math.min(position + 1, target.length);
                vm.searchTypedText = target.slice(0, position);
                if (position >= target.length) {
                    cancelSceneInterval();
                    vm.searchTyping = false;
                    sceneTimeouts.push($timeout(function () {
                        vm.searchButtonPressed = true;
                        sceneTimeouts.push($timeout(function () {
                            vm.searchButtonPressed = false;
                            vm.searchStarted = true;
                            runSearchAnalysis();
                        }, 180));
                    }, 260));
                }
            }, 55);
        }

        function runSearchAnalysis() {
            var started = Date.now();
            var duration = 2200;
            var thresholds = [12, 30, 48, 66, 84];

            sceneInterval = $interval(function () {
                var t = Math.min((Date.now() - started) / duration, 1);
                var eased = t * t * (3 - 2 * t);
                vm.searchProgress = Math.round(eased * 100);
                vm.searchScore = Math.round(vm.initialScore * eased);
                vm.searchChecks.forEach(function (check, index) {
                    check.done = vm.searchProgress >= thresholds[index];
                });
                if (t >= 1) {
                    cancelSceneInterval();
                }
            }, 40);
        }

        function runSolutionsPreview() {
            vm.solutionCount = vm.solutionItems.length;
            vm.solutionItems.forEach(function (item, index) {
                sceneTimeouts.push($timeout(function () {
                    item.visible = true;
                }, 180 + index * 320));
                sceneTimeouts.push($timeout(function () {
                    item.resolved = true;
                    vm.resolvedCount = index + 1;
                    vm.solutionsScore = Math.round(
                        vm.initialScore + (81 - vm.initialScore) * ((index + 1) / vm.solutionItems.length)
                    );
                    vm.problemsFound = Math.max(0, 12 - (index + 1) * 3);
                }, 600 + index * 320));
            });
        }

        function runOutcomePreview() {
            /* The outcome cards animate via CSS when the scene becomes active. */
        }

        function showFinalState() {
            vm.landingScene = 'search';
            vm.searchProgress = 100;
            vm.searchScore = vm.initialScore;
            vm.searchTypedText = 'www.il-tuo-sito.com';
            vm.searchTyping = false;
            vm.searchStarted = true;
            vm.searchButtonPressed = false;
            vm.searchChecks.forEach(function (check) {
                check.done = true;
            });
            vm.solutionCount = vm.solutionItems.length;
            vm.solutionItems.forEach(function (item) {
                item.visible = true;
                item.resolved = true;
            });
            vm.resolvedCount = vm.solutionItems.length;
            vm.solutionsScore = 81;
            vm.problemsFound = 0;
        }

        function cancelSceneInterval() {
            if (sceneInterval) {
                $interval.cancel(sceneInterval);
                sceneInterval = null;
            }
        }

        function clearPreviewTimers() {
            cancelSceneInterval();
            if (sceneTimer) {
                $timeout.cancel(sceneTimer);
                sceneTimer = null;
            }
            sceneTimeouts.forEach(function (timer) {
                $timeout.cancel(timer);
            });
            sceneTimeouts.length = 0;
        }
    }

    SCLandingCtrl.$inject = ['$scope', '$state', '$translate', '$rootScope', 'TypedService', 'AuthService', 'LanguageService', '$window', '$interval', '$timeout'];
    return SCLandingCtrl;
});
